import apiSlice from "./ApiSlice";

const StudentApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // get all delivery dates
        getAllStudentData: builder.query({
            providesTags: ["student"],
            query: (body: PaginationPayloadType) => {
                return {
                    url: "/student",
                    method: "POST",
                    body,
                };
            },
        }),

        // delete delivery date
        deleteStudentById: builder.mutation({
            invalidatesTags: ["student"],
            query: (id: any) => ({
                url: `/student/${id}`,
                method: "DELETE",
            }),
        }),
        // add delivery date
        addStudent: builder.mutation({
            invalidatesTags: ["student"],
            query: (body) => ({
                url: `/student/add`,
                method: "POST",
                body,
            }),
        }),
        //get delivery date by Id
        getStudentById: builder.query({
            providesTags: ["student"],
            query: (id: string) => {
                return {
                    url: `/student/${id}`,
                    method: "GET",
                };
            },
        }),

        // update delivery date
        updateStudentById: builder.mutation({
            invalidatesTags: ["student"],
            query: ({ body, id }) => ({
                url: `/student/${id}`,
                method: "PUT",
                body,
            }),
        }),

        //get Student
        getAllStudent: builder.query({
            providesTags: ["student"],
            query: () => {
                return {
                    url: `/student`,
                    method: "GET",
                };
            },
        }),

        // change status of delivery date
        changeStatusStudentById: builder.mutation({
            invalidatesTags: ["student"],
            query: ({ body, id }) => ({
                url: `/student/status-change/${id}`,
                method: "PUT",
                body,
            }),
        }),
    }),
});

export const {
    useGetAllStudentDataQuery,
    useDeleteStudentByIdMutation,
    useAddStudentMutation,
    useGetAllStudentQuery,
    useGetStudentByIdQuery,
    useUpdateStudentByIdMutation,
    useChangeStatusStudentByIdMutation,
} = StudentApi;
